/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React, { ReactElement } from 'react';
import isNil from 'lodash/isNil';
import { TerminalTypeLabel } from '../../../../../shared/entities/terminal';
import ChartWrapper from './ChartWrapper';
import { getSeriesNameSuffix } from './WithTerminalHistoryChartHOC';

interface NoDataAvailablePlaceholderProps {
  index: number;
  text: string;
  id: string;
  titlePrefixTerminalType?: TerminalTypeLabel;
  children: ReactElement | ReactElement[];
}
const NoDataAvailablePlaceholder = (props: NoDataAvailablePlaceholderProps) => {
  const { index, text, id, children, titlePrefixTerminalType } = props;
  let chartName = text;

  if (!isNil(titlePrefixTerminalType)) {
    chartName = `${getSeriesNameSuffix(titlePrefixTerminalType)}${chartName}`;
  }

  return (
    <ChartWrapper name={chartName} id={id} index={index}>
      {children}
    </ChartWrapper>
  );
};

export default NoDataAvailablePlaceholder;
